import { PrimaryButton } from "@graffer-inc/console-design-kit";
import React from "react";

type Props = {
  onPressSave: () => void;
  disablePressSave: boolean;
  saveLabel: string;
} & (
  | {
      showConfigGroupButton: true;
      onPressConfigGroup: () => void;
      configGroupLabel: string;
    }
  | {
      showConfigGroupButton?: false;
      onPressConfigGroup?: () => void;
      configGroupLabel?: string;
    }
);

export const EditorControl: React.FC<Props> = (props) => {
  const { onPressSave, disablePressSave, saveLabel } = props;
  return (
    <div className="buttons">
      {props.showConfigGroupButton && (
        <PrimaryButton
          text={props.configGroupLabel}
          onClick={props.onPressConfigGroup}
        />
      )}
      <PrimaryButton
        text={saveLabel}
        onClick={onPressSave}
        disabled={disablePressSave}
      />
    </div>
  );
};

export default EditorControl;
